module.exports = __webpack_public_path__ + "static/2019-fineArt5-be7622d10a0255ad399a13c37c0a33d8.jpg";